module.exports = __webpack_public_path__ + "static/media/social2.8b03fd87.svg";